export default __webpack_public_path__ + "static/media/Menu_T-shirt_women.eb41716f.svg";